import services from './services.js';
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate
} from 'utils';
import viewPhoto from 'src/common/js/viewPhoto';
import baseInfoForm from 'agent-base-info';
import areaSelect from 'area-select';
export default {
    mixins: [services],
    components: {
        baseInfoForm,
        'area-select': areaSelect
    },
    data() {
        return {
            visiable: false,
            examineData: this.getSubmitData(),
            title: '',
            baseInfo: null,
            AreaList: [],
            RebateImgs: []
        };
    },
    computed: {
        sysSid: function () {
            return this.$store.state.sysSid;
        },
        sysSession: function () {
            return this.$store.state.sysSession;
        }
    },
    methods: {
        getSubmitData() {
            return cloneDeep({
                "Id": 0,
                "RebateStatus": null,
                "AuditRemark": "",
                "AreaList": []
            });
        },
        handleSelectionChange(val) {
            console.log(val)
            let len = val.length
            this.examineData.AreaList = []
            for (let i = 0; i < len; i++) {
                if (val[i].Id > 0) {
                    this.examineData.AreaList.push(val[i].Id)
                }
            }
        },
        showImgView(img) {
            viewPhoto.show({
                showImgId: "", //指定id显示图片
                thumbList: [{
                    src: img.Url,
                    id: ""
                }]
            });
        },
        close() {
            this.visiable = false;
            this.examineData = this.getSubmitData();
        },
        show(opts) {
            this.visiable = true
            this.title = opts.title
            this.$nextTick(() => {
                this.$refs.baseInfo.resetFields();
            })
            this.GetNewAgentByCustomerId(opts.CustomerId)
            this.GetAgentRebateApplyById(opts.Id)

            this.examineData.Id = opts.Id
        },
        submit() {
            let rules = [{
                name: "审核结果",
                value: this.examineData.RebateStatus,
                required: true
            }]

            if (this.examineData.RebateStatus == 1) {
                rules.push({
                    name: "审核意见",
                    value: this.examineData.AuditRemark,
                    required: true
                })
                this.examineData.AreaList = []
            }
            if (this.examineData.RebateStatus == 2) {
                rules.push({
                    name: "升级区域",
                    value: this.examineData.AreaList,
                    required: true,
                    msg: '请选择升级区域'
                })
                this.examineData.AuditRemark = ''
            }
            var flag = util.checkForm({
                ele: this,
                rules: rules
            });
            if (!flag) {
                return;
            }

            this.RebateApplyAudi(this.examineData);
        }
    }
};


// WEBPACK FOOTER //
// ./src/pages/CRMAgentManage/AgentAudit/components/examinDialog/vm.js